import { TabButtonsSlider } from '../../../js/src/__utils/sliders';

const $ = jQuery.noConflict();

const tabBlocks = document.querySelectorAll('.block-tabs');

const toggleTab = (e) => {
	let currentTab;

	if (e.currentTarget) {
		e.preventDefault();
		currentTab = e.currentTarget;
	} else {
		currentTab = e;
	}

	if (
		!currentTab.classList.contains('active') &&
		currentTab.hasAttribute('data-target')
	) {
		const tabContent = document.getElementById(
			currentTab.getAttribute('data-target')
		);

		const activeElements = tabContent.parentElement.querySelectorAll(
			'.block-tabs__button.active, .block-tabs__tab-content.active'
		);

		if (activeElements.length) {
			activeElements.forEach((activeElement) => {
				activeElement.classList.remove('active');
			});
		}

		currentTab.classList.add('active');

		if (tabContent) {
			tabContent.classList.add('active');
		}

		const activeTab = tabContent.parentElement.querySelector(
			'.block-tabs__button-wrapper.slick-current'
		);

		if (!activeTab) {
			return;
		}

		const tabRect = currentTab.getBoundingClientRect();
		const containerRect = tabContent.parentElement.getBoundingClientRect();
		const slick = tabContent.parentElement.querySelector(
			'.block-tabs__button-row'
		);

		const activeTabIndex = $(activeTab).index();
		const currentTabIndex = $(currentTab.parentElement).index();
		let nextTab = null;

		if (currentTabIndex > activeTabIndex) {
			const additionalSlides = tabContent.parentElement.querySelectorAll(
				'.block-tabs__button-wrapper.slick-current ~ .block-tabs__button-wrapper'
			);

			if (
				currentTab.parentElement.nextElementSibling &&
				tabRect.right + 80 > containerRect.right
			) {
				nextTab = activeTabIndex + 1;
			}

			let containerWithoutSlides =
				containerRect.right + activeTab.offsetWidth;

			if (tabRect.right > containerRect.right) {
				nextTab = activeTabIndex + 1;

				if (tabRect.right > containerWithoutSlides) {
					let nextSet = false;

					additionalSlides.forEach((additionalSlide, index) => {
						if (tabRect.right > containerWithoutSlides) {
							containerWithoutSlides +=
								additionalSlide.offsetWidth;
						} else if (false === nextSet) {
							nextSet = true;
							nextTab += index;
						}
					});
				}
			}
		} else if (
			currentTab.parentElement.previousElementSibling &&
			tabRect.left - 80 < containerRect.left &&
			tabRect.width +
				currentTab.parentElement.previousElementSibling.offsetWidth <
				containerRect.width
		) {
			nextTab = activeTabIndex - 1;
		} else {
			nextTab = activeTabIndex;
		}

		if (null !== nextTab) {
			$(slick).slick('slickGoTo', nextTab);
		}
	}
};

const setTabHeight = () => {
	if (tabBlocks.length) {
		tabBlocks.forEach((tabBlock) => {
			const contentBlocks = tabBlock.querySelectorAll(
				'.block-tabs__tab-content'
			);
			let tallestBlockHeight = 0;
			let oldHeight = tabBlock.style.getPropertyValue('--contentHeight');

			if (!oldHeight) {
				oldHeight = 0;
			} else if (oldHeight.includes('rem')) {
				oldHeight = oldHeight.replace('rem', '') * 16;
			}

			tabBlock.style.removeProperty('--contentHeight');

			if (contentBlocks.length) {
				contentBlocks.forEach((contentBlock) => {
					if (contentBlock.offsetHeight > tallestBlockHeight) {
						tallestBlockHeight = contentBlock.offsetHeight;
					}
				});

				if (tallestBlockHeight < oldHeight) {
					tallestBlockHeight = oldHeight;
				}

				if (tallestBlockHeight > 0) {
					tabBlock.style.setProperty(
						'--contentHeight',
						`${tallestBlockHeight / 16}rem`
					);
				}
			}
		});
	}
};

const showMoreTabContent = (e) => {
	e.preventDefault();

	e.currentTarget.parentElement.classList.remove(
		'block-tabs__tab-content--max-height'
	);
	e.currentTarget.remove();

	setTabHeight();
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (tabBlocks.length) {
			tabBlocks.forEach((tabBlock) => {
				if (tabBlock.hasAttribute('data-max-height')) {
					const maxHeight = tabBlock.getAttribute('data-max-height');
					const tabContents = tabBlock.querySelectorAll(
						'.block-tabs__tab-content'
					);

					if (tabContents.length) {
						tabContents.forEach((tabContent) => {
							if (tabContent.offsetHeight > maxHeight) {
								tabContent.classList.add(
									'block-tabs__tab-content--max-height'
								);

								const loadMoreButton =
									document.createElement('button');

								loadMoreButton.classList.add(
									'c-btn',
									'c-btn-secondary',
									'block-tabs__load-more-button'
								);

								loadMoreButton.textContent = 'Show More';

								tabContent.appendChild(loadMoreButton);

								loadMoreButton.addEventListener(
									'click',
									showMoreTabContent
								);
							}
						});
					}
				}

				const tabButtons = tabBlock.querySelectorAll(
					'.block-tabs__button'
				);
				const buttonRow = tabBlock.querySelector(
					'.block-tabs__button-row'
				);

				if (tabButtons.length && buttonRow) {
					tabButtons.forEach((tabButton, index) => {
						buttonRow.appendChild(tabButton.parentElement);

						if (0 === index) {
							toggleTab(tabButton);
						}

						tabButton.addEventListener('click', toggleTab);
					});
				}

				tabBlock.classList.add('initialized');
			});

			TabButtonsSlider.init();
		}

		setTabHeight();
	},
	loaded() {},
	resized() {
		setTabHeight();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
